import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { usePermitApplicationContext } from "./PermitApplicationContext";
import { UploadDocumentsStepContent } from "./components/UploadDocumentsStepContent";

export const UploadDocumentsStep: React.FC = () => {
  const { state } = usePermitApplicationContext();
  const { documents } = state;
  const { permitType } = state.permitTypeSelection;
  const { authorityId } = state.authority;

  if (!authorityId) {
    return (
      <Box sx={{ textAlign: "center", py: 6 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No Authority Selected
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please go back and select an authority first.
        </Typography>
      </Box>
    );
  }

  if (!permitType) {
    return (
      <Box sx={{ textAlign: "center", py: 6 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No Permit Type Selected
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please go back and select a permit type first.
        </Typography>
      </Box>
    );
  }

  return (
    <UploadDocumentsStepContent documents={documents} permitTypeName={permitType.name} payeeAccountId={authorityId} />
  );
};

export default UploadDocumentsStep;
